<template>
  <div class="level">
    <qd-collapse class="column is-5 is-paddingless" >
      <div class="columns is-multiline is-marginless subMenu">
        <div class="column is-12 is-paddingless">
          <div class="level-right">
            <button @click="close()" class="button is-subMenu">
              <b-icon icon="close"
                      custom-size="mdi-10px"
                      type="is-white">
              </b-icon>
            </button>
          </div>
          <display-menu-and-sub-menu :menuAndSubMenu="baux">
          </display-menu-and-sub-menu>
        </div>
      </div>
    </qd-collapse>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import displayMenuAndSubMenu from '@/components/sideBar/submenuSidebar/displayMenuAndSubMenu';
import {
  CONTRAT,
  BAILLEUR,
  CONSTATATION_CHARGE,
  ECHEANCIER_CONTRAT,
  FACTURE_ACHAT,
  DEMARCHEUR,
  JOURNAL_PAIEMENTS,
  COMMANDE_ACHAT,
} from '@/configuration/baux/permissionsBauxConf';
import {
  SET_INDEX_SUB_MENU_OPEN,
  SET_BAUX_MENU,
} from '@/store/modules/menu/menu-mutation-type';
import { CATALOGUE, REMISES_BANCAIRES } from '@/configuration/permissionsBodacConf';

const menu = createNamespacedHelpers('menu');

export default {
  name: 'SidebarBaux',
  components: {
    displayMenuAndSubMenu,
  },
  data() {
    return {
      baux: [
        {
          title: 'sidebar.baux.contrat',
          noSubMenu: false,
          data: [
            { name: 'sidebar.baux.contrat', path: 'l.baux.contrat', perm: CONTRAT.lecture },
            { name: 'sidebar.baux.constatationCharge', path: 'l.baux.constatation_charge', perm: CONSTATATION_CHARGE.lecture },
            { name: 'sidebar.baux.commandeAchat', path: 'l.baux.commande_achat-bailleur', perm: COMMANDE_ACHAT.lecture },
            { name: 'sidebar.baux.depenseBailleur', path: 'l.baux.facture_achat-bailleur', perm: FACTURE_ACHAT.lecture },
            { name: 'sidebar.baux.echeancesAPayer', path: 'l.baux.echeancier_contrat', perm: ECHEANCIER_CONTRAT.lecture },
            { name: 'sidebar.baux.lotPaiement', path: 'l.baux.lot_paiement', perm: REMISES_BANCAIRES.lecture },
            { name: 'sidebar.baux.journalPaiements', path: 'l.baux.journal_paiements', perm: JOURNAL_PAIEMENTS.lecture },
          ],
        },
        {
          title: 'sidebar.baux.produitAchat',
          path: 'l.bodac.catalogue-produitAchatLoc',
          noSubMenu: true,
          perm: CATALOGUE.lecture,
        },
        {
          title: 'sidebar.baux.bailleur',
          noSubMenu: true,
          path: 'l.baux.bailleur',
          perm: BAILLEUR.lecture,
        },
        {
          title: 'sidebar.baux.demarcheur',
          noSubMenu: true,
          path: 'l.baux.demarcheur',
          perm: DEMARCHEUR.lecture,
        },
      ],
    };
  },
  methods: {
    ...menu.mapMutations({
      setBauxMenu: SET_BAUX_MENU,
      setIndexSubMenu: SET_INDEX_SUB_MENU_OPEN,
    }),
    close() {
      this.setBauxMenu(false);
      this.setIndexSubMenu(null);
    },
  },
};
</script>

<style scoped>

</style>
